import BrandLogo from './BrandLogo';

function Hero() {
  return (
    <section className="hero hero--rider" id="top" aria-labelledby="hero-heading">
      <div className="hero__media" aria-hidden="true">
        <div className="hero__wash" />
        <div className="hero__grain" />
      </div>

      <div className="hero__content">
        <div className="hero__brand-row reveal">
          <BrandLogo size="lg" className="hero__logo" />
          <p className="hero__brand">Saarthi</p>
        </div>
        <h1 id="hero-heading" className="hero__title reveal reveal--delay-1">
          Your ride,
          <span>your way.</span>
        </h1>
        <p className="hero__lead reveal reveal--delay-2">
          Instant city trips in the app, or hire a car for outstation and planned travel — backed by
          a professional driver fleet.
        </p>
        <div className="hero__actions hero__actions--duo reveal reveal--delay-3">
          <a href="#instant-ride" className="hero-ride-cta hero-ride-cta--instant">
            <span className="hero-ride-cta__label">Instant ride</span>
            <span className="hero-ride-cta__hint">City · book now in app</span>
          </a>
          <a href="#hire-a-car" className="hero-ride-cta hero-ride-cta--hire">
            <span className="hero-ride-cta__label">Hire a car</span>
            <span className="hero-ride-cta__hint">Outstation · request online</span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
